import { useNavigate } from 'react-router-dom';
import AdultingSocialLinksCard from '@/components/AdultingSocialLinksCard';
import LegalLinks from '@/components/LegalLinks';
import {
  ABOUT_PAGE_CONTENT,
  AppButton,
  AppButtonRow,
  AppCard,
  AppCardBody,
  AppCardHeader,
  AppPage,
  AppPageIntro,
  AppSectionHeader,
  PUBLIC_CORE_LINK_LABELS,
} from '../../ui-foundation';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <AppPage className="animate-fade-in">
      <AppPageIntro title={ABOUT_PAGE_CONTENT.title} subtitle={ABOUT_PAGE_CONTENT.subtitle} />

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={ABOUT_PAGE_CONTENT.introTitle} subtitle={ABOUT_PAGE_CONTENT.introSubtitle} />
        </AppCardHeader>
        <AppCardBody>
          <p className="text-sm leading-relaxed text-muted-foreground">{ABOUT_PAGE_CONTENT.introBody}</p>
        </AppCardBody>
      </AppCard>

      {ABOUT_PAGE_CONTENT.pillars.map((pillar) => (
        <AppCard key={pillar.title}>
          <AppCardHeader>
            <AppSectionHeader title={pillar.title} />
          </AppCardHeader>
          <AppCardBody>
            <p className="text-sm leading-relaxed text-muted-foreground">{pillar.body}</p>
          </AppCardBody>
        </AppCard>
      ))}

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={ABOUT_PAGE_CONTENT.betaTitle} />
        </AppCardHeader>
        <AppCardBody>
          <div className="space-y-2 text-sm leading-relaxed text-muted-foreground">
            {ABOUT_PAGE_CONTENT.betaBody.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </AppCardBody>
      </AppCard>

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={ABOUT_PAGE_CONTENT.notTitle} />
        </AppCardHeader>
        <AppCardBody>
          <div className="space-y-2 text-sm leading-relaxed text-muted-foreground">
            {ABOUT_PAGE_CONTENT.notBody.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </AppCardBody>
      </AppCard>

      <AdultingSocialLinksCard
        sourceScreen="about"
        helperText={ABOUT_PAGE_CONTENT.socialHelper}
      />

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title="Where to look next" />
        </AppCardHeader>
        <AppCardBody>
          <AppButtonRow>
            <AppButton size="sm" tone="outline" onPress={() => navigate('/privacy')}>
              {PUBLIC_CORE_LINK_LABELS.privacy}
            </AppButton>
            <AppButton size="sm" tone="outline" onPress={() => navigate('/terms')}>
              {PUBLIC_CORE_LINK_LABELS.terms}
            </AppButton>
            <AppButton size="sm" tone="outline" onPress={() => navigate('/gdpr')}>
              {PUBLIC_CORE_LINK_LABELS.gdpr}
            </AppButton>
            <AppButton size="sm" tone="outline" onPress={() => navigate('/community-guidelines')}>
              {PUBLIC_CORE_LINK_LABELS.communityGuidelines}
            </AppButton>
            <AppButton size="sm" tone="outline" onPress={() => navigate('/contact-complaints')}>
              {PUBLIC_CORE_LINK_LABELS.contactSupport}
            </AppButton>
          </AppButtonRow>
        </AppCardBody>
      </AppCard>

      <div className="pt-2">
        <LegalLinks hideWhenAuthenticated tone="public" />
      </div>

    </AppPage>
  );
}
